class DZModelLink{

    /**
     * 主键
     */
    id = "";

    /**
     * 标题
     */
    title = "";

    /**
     * 链接
     */
    url = "";

    /**
     * 排序
     */
    sort = "";

}
export default DZModelLink;
